/**
 * Created by Daniela on 29/09/2016.
 */
import { Directive, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[codigoMask]'
})
export class CodigoMaskMaskDirective {
    private _defaultValue = 10;
    
    constructor(
        public model: NgControl
    ) {}

    @Input('codigoMask') codigoLimit: number;

    @HostListener('ngModelChange') ngModelChange() {
        this.modelValue();
    }

    private modelValue() {
        if (this.model) {
            var model: any = this.model;
            if(model.viewModel) {
                if (typeof model.viewModel === 'number') {
                    model.viewModel = model.viewModel.toString();
                }
                this.inputChange(model.viewModel);
            }
        }
    }

    private inputChange(model: any) {
        if (model) {
            var newVal = model,
                valueLength = model.length;

            setTimeout(function() {
                if (!this.codigoLimit) {
                    this.codigoLimit = this._defaultValue;
                } 
                if (valueLength == 0) {
                    newVal = '';
                } else {
                    var x: any, lenX: any;
                    for (x = valueLength, lenX = this.codigoLimit; x < lenX; x++) {
                        newVal = "0" + newVal;
                    }
                }

                this.model.valueAccessor.writeValue(newVal);
            }.bind(this));
        }
    }
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/shared/directives/codigo-mask.directive.ts
 **/